import axios from "axios";
import { useEffect, useState } from "react";

const GetLeadStatusData = ({onStatusChange, selectedStatus, totalLeads, leadStatusCount}) => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);

    const handleStatusCLick = (status) => {
        const newStatus = selectedStatus === status ? null : status;
        onStatusChange(newStatus);
    };
    return(
        <div className="bg-white flex flex-col item-start shadow-lg rounded-lg p-4 mb-4 w-full h-fit">
            <h1 className="font-bold">Your Total Leads ({totalLeads})</h1>
            <div className="flex flex-row justify-between">
                <div 
                    onClick={() => handleStatusCLick('Active')}
                    className={`bg-gray-100 rounded-lg p-4 m-4 w-1/4 h-fit flex justify-between items-center cursor-pointer transition-all ${
                        selectedStatus === 'Active' ? "ring-2 ring-blue-500" : ""
                    } hover:bg-gray-200`}
                    role="button"
                    tabIndex={0}>
                    <div>
                        <h3 className="font-bold">Active</h3>
                        <a>last 7 days</a>
                    </div>
                    <span className="text-xl font-bold">{leadStatusCount.find(item => item.lead_status === 'Active')?.count || ""}</span>
                </div>

                <div 
                    onClick={() => handleStatusCLick('Ongoing')}
                    className={`bg-gray-100 rounded-lg p-4 m-4 w-1/4 h-fit flex justify-between items-center cursor-pointer transition-all ${
                        selectedStatus === 'Ongoing' ? "ring-2 ring-blue-500" : ""
                    } hover:bg-gray-200`}
                    role="button"
                    tabIndex={0}>
                    <div>
                        <h3 className="font-bold">Ongoing</h3>
                        <a>last 40 days</a>
                    </div>
                    <span className="text-xl font-bold">{leadStatusCount.find(item => item.lead_status === 'Ongoing')?.count || ""}</span>
                </div>

                <div 
                    onClick={() => handleStatusCLick('Inactive')}
                    className={`bg-gray-100 rounded-lg p-4 m-4 w-1/4 h-fit flex justify-between items-center cursor-pointer transition-all ${
                        selectedStatus === 'Inactive' ? "ring-2 ring-blue-500" : ""
                    } hover:bg-gray-200`}
                    role="button"
                    tabIndex={0}>
                    <div>
                        <h3 className="font-bold">Inactive</h3>
                        <a>&gt; 40 days</a>
                    </div>
                    <span className="text-xl font-bold">{leadStatusCount.find(item => item.lead_status === 'Inactive')?.count || ""}</span>
                </div>

                <div 
                    onClick={() => handleStatusCLick('Tanked')}
                    className={`bg-gray-100 rounded-lg p-4 m-4 w-1/4 h-fit flex justify-between items-center cursor-pointer transition-all ${
                        selectedStatus === 'Tanked' ? "ring-2 ring-blue-500" : ""
                    } hover:bg-gray-200`}
                    role="button"
                    tabIndex={0}>
                    <div>
                        <h3 className="font-bold">Tanked</h3>
                        <a>&gt; 90 days</a>
                    </div>
                    <span className="text-xl font-bold">{leadStatusCount.find(item => item.lead_status === 'Tanked')?.count || ""}</span>
                </div>
            </div>
        </div>
    )
}

export default GetLeadStatusData;